<template>
  <div class="page-shell">
    <router-view />
  </div>
</template>
